const _jsxFileName = "C:\\Users\\MartinStein\\Documents\\Development\\KOMMUTER\\ride-sharing-app\\app\\js\\ride-sharing-app\\components\\UserSettings.tsx"; function _nullishCoalesce(lhs, rhsFn) { if (lhs != null) { return lhs; } else { return rhsFn(); } } function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }import { PageHeader } from "@ant-design/pro-layout";
import { useTranslation, useUrlParam } from "@opendash/core";
import { Icon } from "@opendash/icons";
import { Button, List, Card, Avatar, Skeleton, Tag } from "antd";
import React, { useEffect } from "react";
import Parse from "parse";
import {
  ListContainer,
  UserBlacklistList,
  UserLanguageSelection,
  UserLogout,
  UserPredefinedSearch,
  UserProfile,
  UserProfileImage,
  UserQuickMessage,
  getUserProfile,
  getProfileImage,
} from "..";

import { UserPasswordChange } from "./UserPasswordChange";

export function UserSettings() {
  const t = useTranslation();
  const user = Parse.User.current();
  const [tenant, setTenant] = React.useState(null);

  React.useMemo(async () => {}, [user]);
  const [tab, setTab] = useUrlParam("tab", null);
  useEffect(() => {
    const init = async () => {
      if (user) {
        const pTenant = _optionalChain([user, 'optionalAccess', _ => _.get, 'call', _2 => _2("tenant")]);
        await pTenant.fetch();
        setTenant(pTenant);
      }
    };
    init();
  }, [user]);
  const tabs = React.useMemo(
    () => [
      {
        key: "profile",
        label: t("rs:profile.default_tab"),
        component: UserProfile,
      },
      {
        key: "search",
        label: t("rs:profile.search_tab"),
        component: UserProfile,
      },
      {
        key: "offer",
        label: t("rs:profile.offer_tab"),
        component: UserProfile,
      },
      {
        key: "accessibility",
        label: t("rs:profile.accessibility_tab"),
        component: UserProfile,
      },
      {
        key: "image",
        label: t("parse-custom:classes.RideSharingProfile.fields.image"),
        component: UserProfileImage,
      },
      {
        key: "blacklist",
        label: t("rs:user.blacklist.headline"),
        component: UserBlacklistList,
      },
      ...(getUserProfile().accessibilityUsePredefinedSearch
        ? [
            {
              key: "predefined-search",
              label: t("rs:profile.predefined_search_tab"),
              component: UserPredefinedSearch,
            },
          ]
        : []),
      ...(getUserProfile().accessibilityUsePredefinedSearch
        ? [
            {
              key: "quickmessages",
              label: t("rs:profile.predefined_message_tab"),
              component: UserQuickMessage,
            },
          ]
        : []),
      {
        key: "language",
        label: t("rs:user.language"),
        component: UserLanguageSelection,
      },
      {
        key: "password",
        label: t("rs:user.password"),
        component: UserPasswordChange,
      },
      {
        key: "logout",
        label: t("rs:user.logout.headline"),
        component: UserLogout,
      },
    ],
    [t]
  );

  const activeTab = tabs.find((t) => t.key === tab);
  const headline = _nullishCoalesce(_optionalChain([activeTab, 'optionalAccess', _3 => _3.label]), () => ( t("rs:profile.label")));
  const Component = _optionalChain([activeTab, 'optionalAccess', _4 => _4.component]);
  const avatar = getProfileImage(user);
  return (
    React.createElement(React.Fragment, null
      , React.createElement(PageHeader, {
        title: headline,
        onBack: !tab ? undefined : () => setTab(null), __self: this, __source: {fileName: _jsxFileName, lineNumber: 114}}
      )
      , user && (
        React.createElement(Card, {
          style: {
            marginBottom: 16,
            borderTop: "1px solid #ddd",
            borderBottom: "1px solid #ddd",
          }, __self: this, __source: {fileName: _jsxFileName, lineNumber: 119}}






          , React.createElement(Card.Meta, {
            avatar: 
              React.createElement(Avatar, {
                icon: 
                  avatar ? undefined : (
                    React.createElement(Icon, {
                      icon: "ai:user",
                      style: { lineHeight: "40px", height: "40px" }, __self: this, __source: {fileName: _jsxFileName, lineNumber: 136}}
                    )
                  )
                ,
                src: avatar ? avatar : undefined,
                size: "large", __self: this, __source: {fileName: _jsxFileName, lineNumber: 133}}
              )
            ,
            title: `${user.get("name")}`,
            description: user.get("email"), __self: this, __source: {fileName: _jsxFileName, lineNumber: 131}}
          )
          , tenant && (
            React.createElement(Tag, { style: { float: "right" }, __self: this, __source: {fileName: _jsxFileName, lineNumber: 150}}, _optionalChain([tenant, 'optionalAccess', _5 => _5.get, 'call', _6 => _6("label")]))
          )
          , !tenant && React.createElement(Skeleton, { active: true, __self: this, __source: {fileName: _jsxFileName, lineNumber: 152}} )
        )
      )
      , React.createElement(ListContainer, {__self: this, __source: {fileName: _jsxFileName, lineNumber: 155}}
        , activeTab && React.createElement(Component, {__self: this, __source: {fileName: _jsxFileName, lineNumber: 156}} )
        , !activeTab && (
          React.createElement(List, {
            dataSource: tabs,
            renderItem: (item) => (
              React.createElement(List.Item, {
                onClick: () => {
                  if (item.component) {
                    setTab(item.key);
                  }
                },
                extra: React.createElement(Button, { type: "link", icon: React.createElement(Icon, { icon: "ai:right", __self: this, __source: {fileName: _jsxFileName, lineNumber: 167}} ), __self: this, __source: {fileName: _jsxFileName, lineNumber: 167}} ), __self: this, __source: {fileName: _jsxFileName, lineNumber: 161}}

                , React.createElement(List.Item.Meta, { title: item.label, __self: this, __source: {fileName: _jsxFileName, lineNumber: 169}} )
              )
            ), __self: this, __source: {fileName: _jsxFileName, lineNumber: 158}}
          )
        )
      )
    )
  );
}
